import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLandingLang } from "@/components/FundingCaseStudy";
import { useJsonLd, faqLd } from "@/lib/seo";

export function useSiteFaq(placement, lang) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/public/site-faq", { params: { placement, lang: lang === "es" ? "es" : "" } }).then((r) => setRows(r.data)).catch(() => {}); }, [placement, lang]);
  return rows;
}

export function HomeFaq() {
  const lang = useLandingLang();
  const rows = useSiteFaq("home", lang);
  useJsonLd("home-faq", rows.length ? faqLd(rows.map((r) => [r.q, r.a])) : null);
  if (!rows.length) return null;
  return (
    <section className="border-b border-slate-200 bg-white" data-no-translate lang={lang} data-testid="home-faq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">{lang === "es" ? "Preguntas frecuentes" : "Common questions"}</h2>
        <div className="mt-8 divide-y divide-slate-200 border-y border-slate-200">{rows.map((r, i) => (
          <details key={r.faq_id} className="py-4 group" data-testid={`home-faq-${i}`}><summary className="cursor-pointer font-semibold text-slate-900 list-none flex justify-between gap-4">{r.q}<span className="text-emerald-600 transition-transform group-open:rotate-45">+</span></summary><p className="mt-2 text-slate-600">{r.a}</p></details>))}</div>
      </div>
    </section>
  );
}
